import React, { useEffect, useState } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchRentersRegisteredRenters,
  initializeRentersRegisteredRentersScreen,
  setDeleteConfirmationPopupVisibility,
  exportRentersRegisteredRenters
} from "../../../redux/actions/Renters/RentersRegisteredRenters";
import RentersRegisteredRenters from '../../../component/Renters/RentersRegisteredRenters';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function RentersRegisteredRentersScreen(props) {
  const {
    fetchRentersRegisteredRenters,
    initRentersRegisteredRentersScreen,
    showPageLevelLoader,
    RentersRegisteredRentersListview,
    paginationInfo,
    exportRentersRegisteredRenters,
    isRentersRegisteredRentersExportError,
    isRentersRegisteredRentersExportSuccess,
    isLoading,
  } = props;
  const navigate = useNavigate();
  useEffect(() => {
    initRentersRegisteredRentersScreen();
    fetchRentersRegisteredRenters({ sortField: 'id', userId: localStorage.getItem("userId") });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    let newProps = {
      ...props,
      userId: localStorage.getItem("userId")
    }
    fetchRentersRegisteredRenters(newProps);
  };
  const handleCreateRentersRegisteredRenters = () => {
    navigate(APP_URLS.RENTERS_REGISTEREDRENTERS.CREATE);
  }
  const editRentersRegisteredRentersRoute = (id) => {
    const path = generatePath(APP_URLS.RENTERS_REGISTEREDRENTERS.VIEW, {
      id,
    });
    navigate(path);
  };
  const RentersRegisteredRentersProps = {
    handleCreateRentersRegisteredRenters,
    exportRentersRegisteredRenters,
    isRentersRegisteredRentersExportError,
    isRentersRegisteredRentersExportSuccess,
    editRentersRegisteredRentersRoute,
    ...companyData,
    screenPermissions: companyData?.screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchRentersRegisteredRenterss: loadLazyData,
    ...companyData,
    tableData: {
      columns: RentersRegisteredRentersListview?.columns,
      rows: RentersRegisteredRentersListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <RentersRegisteredRenters
        {...RentersRegisteredRentersProps}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initRentersRegisteredRentersScreen: () => dispatch(initializeRentersRegisteredRentersScreen()),
    fetchRentersRegisteredRenters: (payload) => dispatch(fetchRentersRegisteredRenters(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportRentersRegisteredRenters: (payload) => dispatch(exportRentersRegisteredRenters(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isRentersRegisteredRentersCreateSuccess: selectFromRentersRegisteredRentersReducer(
      state,
      "isRentersRegisteredRentersCreateSuccess"
    ),
    RentersRegisteredRentersListview: selectFromRentersRegisteredRentersReducer(
      state,
      "RentersRegisteredRentersListview"
    ),
    showPageLevelLoader: selectFromRentersRegisteredRentersReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRentersRegisteredRentersReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromRentersRegisteredRentersReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRentersRegisteredRentersReducer(
      state,
      "isFetchingGridData"
    ),
    isRentersRegisteredRentersExportError: selectFromRentersRegisteredRentersReducer(
      state,
      "isRentersRegisteredRentersExportError"
    ),
    isRentersRegisteredRentersExportSuccess: selectFromRentersRegisteredRentersReducer(
      state,
      "isRentersRegisteredRentersExportSuccess"
    ),
    isLoading: selectFromRentersRegisteredRentersReducer(
      state,
      "isLoading"
    ),
    ...ownProps,
  };
};

const selectFromRentersRegisteredRentersReducer = (state, path) => {
  return selectRentersRegisteredRentersReducer(state)[path];
};

const selectRentersRegisteredRentersReducer = ({ RentersRegisteredRentersReducer }) => {
  return RentersRegisteredRentersReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(RentersRegisteredRentersScreen);
